import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from '@/pages/Dashboard';
import Bots from '@/pages/Bots';
import Positions from '@/pages/Positions';
import Realtime from '@/pages/Realtime';
import Admin from '@/pages/Admin';
import MyExchange from '@/pages/MyExchange';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/bots" element={<Bots />} />
          <Route path="/positions" element={<Positions />} />
          <Route path="/realtime" element={<Realtime />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/my-exchange" element={<MyExchange />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;







